export const getters = {
  LaboursitemsRows: state => state.labour_item,
  systemnumberlessLabours: state => state.numberlesslabours,
  EditLaboursCharges: state => state.labour_items
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/numberlesslabours/getters.js